var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnableCaptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2944 13.5129C16.0884 13.5129 16.7319 12.8693 16.7319 12.0754M16.7319 7.6246V3.17383C16.7319 2.37992 16.0884 1.73633 15.2944 1.73633H2.70508C1.91117 1.73633 1.26758 2.37993 1.26758 3.17383V12.0754C1.26758 12.8693 1.91117 13.5129 2.70508 13.5129H3.68634V15.5443C3.68634 16.1237 4.33684 16.4649 4.8136 16.1356L7 13.5",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82812 9.06055H9.78448",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0921 11.2441H8.13574",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1514 9.06055H14.0916",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76838 11.2441H3.82812",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.3125C8 11.8788 8.11153 12.4396 8.32828 12.9628C8.54495 13.486 8.86265 13.9614 9.26308 14.3618C9.66358 14.7623 10.1389 15.08 10.6622 15.2967C11.1854 15.5135 11.7462 15.625 12.3125 15.625C12.8788 15.625 13.4396 15.5135 13.9628 15.2967C14.486 15.08 14.9614 14.7623 15.3618 14.3618C15.7623 13.9614 16.08 13.486 16.2967 12.9628C16.5135 12.4396 16.625 11.8788 16.625 11.3125C16.625 10.7462 16.5135 10.1854 16.2967 9.6622C16.08 9.13893 15.7623 8.66358 15.3618 8.26308C14.9614 7.86265 14.486 7.54495 13.9628 7.32828C13.4396 7.11153 12.8788 7 12.3125 7C11.7462 7 11.1854 7.11153 10.6622 7.32828C10.1389 7.54495 9.66358 7.86265 9.26308 8.26308C8.86265 8.66358 8.54495 9.13893 8.32828 9.6622C8.11153 10.1854 8 10.7462 8 11.3125Z",
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2627 14.3603L15.3612 8.26172Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2627 14.3603L15.3612 8.26172",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnableCaptions);
export default __webpack_public_path__ + "static/media/enable_captions.72a094259362709456c109ccb3afd314.svg";
export { ForwardRef as ReactComponent };